import React from 'react';
import { CheckCircle2, History, RefreshCw, XCircle } from 'lucide-react';

const PublishOverlay = ({ status, type, totalAccounts, onHistory, onGotIt, platforms }) => {
    const [progress, setProgress] = React.useState(0);
    console.log(status)
    React.useEffect(() => {
        let timer;
        if (status === 'processing' && type === 'publish') {
            setProgress(0);
            const interval = totalAccounts > 10 ? 1000 : 1500;

            timer = setInterval(() => {
                setProgress(prev => {
                    if (prev >= totalAccounts) {
                        clearInterval(timer);
                        return totalAccounts;
                    }
                    return prev + 1;
                });
            }, interval);
        }
        return () => clearInterval(timer);
    }, [status, type, totalAccounts]);

    if (status === 'idle') return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 animate-in fade-in duration-300">
            <div className="bg-white/90 p-8 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-white/50 max-w-sm w-full text-center space-y-6 animate-in zoom-in-95 duration-300">
                <div className="flex justify-center">
                    {status === 'processing' && (
                        <div className="relative flex items-center justify-center p-4 bg-red-50 rounded-full">
                            <RefreshCw size={44} className="text-red-600 animate-spin" />
                            {type === 'publish' && (
                                <span className="absolute text-[11px] font-black text-red-700">
                                    {progress}/{totalAccounts}
                                </span>
                            )}
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="bg-green-50 p-4 rounded-full animate-in zoom-in duration-500">
                            <CheckCircle2 size={48} className="text-green-500" />
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="bg-red-50 p-4 rounded-full animate-in zoom-in shake duration-500">
                            <XCircle size={48} className="text-red-500" />
                        </div>
                    )}
                </div>

                <div className="space-y-2">
                    <h3 className="text-lg font-bold">
                        {status === 'processing' ? 'Processing Request' : 'All Set!'}
                    </h3>
                    <p className="text-sm text-gray-500 font-medium px-4 leading-relaxed">
                        {status === 'processing' && (
                            type === 'publish'
                                ? "We are dispatching to your accounts. This may take a moment..."
                                : "Saving your changes to the database..."
                        )}

                        {status === 'success' && (
                            type === 'publish'
                                ? "Your post is published! You can check the final result in history."
                                : "Great! Your request has been handled successfully."
                        )}

                        {status === 'error' && (
                            "Oops! Something went wrong while processing your request. Please try again or contact support if the issue persists."
                        )}
                    </p>
                </div>

                {type === 'publish' && status === 'processing' && (
                    <div className="w-full bg-gray-100 h-1 rounded-full overflow-hidden">
                        <div
                            className="bg-red-600 h-full transition-all duration-500"
                            style={{ width: `${(progress / totalAccounts) * 100}%` }}
                        />
                    </div>
                )}

                {status === 'success' && platforms.includes("tiktok") && (
                    <p className="text-sm text-gray-600 mt-2 flex items-start gap-2">
                        <span className="text-black font-bold">•</span>
                        <span>
                            <strong>TikTok:</strong> Your video has been sent successfully. Please note that TikTok requires a few minutes to process and scan your content before it becomes visible on your profile.
                        </span>
                    </p>
                )}

                {status === 'success' && platforms.includes("youtube") && (
                    <p className="text-sm text-gray-600 mt-2 flex items-start gap-2">
                        <span className="text-red-600 font-bold">•</span>
                        <span>
                            <strong>YouTube:</strong> Upload complete! YouTube is currently transcoding your video for high-quality playback. It will appear in your channel as soon as the processing is finished.
                        </span>
                    </p>
                )}
                {status === 'success' && (
                    <div className="flex flex-col gap-2 pt-2">
                        <button onClick={onHistory} className="w-full py-3 bg-red-600 text-white font-bold rounded-xl shadow-lg shadow-red-100 flex items-center justify-center gap-2">
                            <History size={18} /> View History
                        </button>
                        <button onClick={onGotIt} className="w-full py-3 bg-red-600 text-white font-bold rounded-xl shadow-lg shadow-red-100 flex items-center justify-center gap-2">Dismiss</button>
                    </div>
                )}
                {status === 'error' && (
                    <div className="flex flex-col gap-2 pt-2">
                        <button onClick={onGotIt} className="w-full py-3 bg-red-600 text-white font-bold rounded-xl shadow-lg shadow-red-100 flex items-center justify-center gap-2">Dismiss</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PublishOverlay;